<template>
  <div class="dot-isloading">
    <div class="lds-ellipsis">
      <div />
      <div />
      <div />
      <div />
    </div>
  </div>
</template>
<script>
export default {
  name: "DotLoading",
};
</script>
<style lang="scss">
.dot-isloading {
  @include auto_margin_top(40px);
  @include flex_align;
  justify-content: center;
}
</style>